<template>
  <button class="tw-flex tw-flex-row tw-items-center" type="submit" :disabled="loading">
    <font-awesome-icon v-if="loading" class="text-icon" icon="spinner" spin />
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
}
</script>
<style scoped>
.text-icon {
  margin-right: 10px;
}
</style>
